var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainpage"},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"head-right"},[_c('div',{class:_vm.btname == 'left'
            ? 'head-right-bt head-right-bt-active'
            : 'head-right-bt',on:{"click":function($event){return _vm.clickbt('left', 'Specialinformation')}}},[_vm._v(" 专题资讯 ")]),_c('div',{class:_vm.btname == 'right'
            ? 'head-right-bt head-right-bt-active'
            : 'head-right-bt',on:{"click":function($event){return _vm.clickbt('right', 'Eventnews')}}},[_vm._v(" 活动新闻 ")])])]),_c('div',{staticClass:"line"}),_c(_vm.componentId,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }